import {types} from '../../types';

const setGetListAdminAction = (payload) => {
  return {
    type: types.admin.SET_LIST,
    payload,
  }
}

const setGetListHistoryAction = (payload) => {
  return {
    type: types.admin.SET_HISTORY,
    payload,
  }
}

const setGetListEventsAction = (payload) => {
  return {
    type: types.admin.SET_EVENT,
    payload,
  }
}

const setGetViewAdminAction = (payload) => {
  return {
    type: types.admin.SET_VIEW,
    payload
  }
}

export {
  setGetListAdminAction as SetGetListAdminAction,
  setGetListHistoryAction as SetGetListHistoryAction,
  setGetListEventsAction as SetGetListEventsAction,
  setGetViewAdminAction as SetGetViewAdminAction
}